module.exports = __webpack_public_path__ + "static/media/workspace.b64e1f9b.png";